import { useState } from "react";
import "./App.css";
import BetaBanner from "./components/BetaBanner";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import CommunitySection from "./components/CommunitySection";
import ArticlesSection from "./components/ArticlesSection";
import EShopSection from "./components/EShopSection";
import CreatorsSection from "./components/CreatorsSection";
import DownloadSection from "./components/DownloadSection";
import Footer from "./components/Footer";
import AboutModal from "./components/AboutModal";
import FAQModal from "./components/FAQModal";
import ContactModal from "./components/ContactModal";
import BetaSignupModal from "./components/BetaSignupModal";
import AdminPage from "./components/AdminPage";
import PrivacyPage from "./components/PrivacyPage";
import TermsPage from "./components/TermsPage";
import DeleteAccountPage from "./components/DeleteAccountPage";

const path = window.location.pathname;

function App() {
  const [showAbout, setShowAbout]     = useState(false);
  const [showFAQ, setShowFAQ]         = useState(false);
  const [showBeta, setShowBeta]       = useState(false);
  const [showContact, setShowContact] = useState(false);

  if (path === "/admin")   return <AdminPage />;
  if (path === "/privacy") return <PrivacyPage />;
  if (path === "/terms")   return <TermsPage />;
  if (path === "/delete-account") return <DeleteAccountPage />;

  return (
    <div className="App bg-[#0C0E13] min-h-screen overflow-x-hidden">
      <BetaBanner onGetIt={() => setShowBeta(true)} />
      <Navbar
        onAbout={() => setShowAbout(true)}
        onFAQ={() => setShowFAQ(true)}
        onGetApp={() => setShowBeta(true)}
        onContact={() => setShowContact(true)}
      />
      <HeroSection onGetApp={() => setShowBeta(true)} />
      <CommunitySection />
      <ArticlesSection />
      <EShopSection />
      <CreatorsSection />
      <DownloadSection onGetApp={() => setShowBeta(true)} />
      <Footer
        onAbout={() => setShowAbout(true)}
        onFAQ={() => setShowFAQ(true)}
        onContact={() => setShowContact(true)}
      />
      <AboutModal   open={showAbout}   onClose={() => setShowAbout(false)} />
      <FAQModal     open={showFAQ}     onClose={() => setShowFAQ(false)} />
      <ContactModal open={showContact} onClose={() => setShowContact(false)} />
      <BetaSignupModal open={showBeta} onClose={() => setShowBeta(false)} />
    </div>
  );
}

export default App;
